import React from 'react';
import TimelineItem from './TimelineItem';
import './Timeline.css'; // Make sure this CSS file exists and is correctly configured

const Timeline = ({ items }) => {
  return (
    <div className="timeline-container">
      {items && items.map((item, index) => (
        <TimelineItem key={index} item={item} />
      ))}
    </div>
  );
};

export default Timeline;
